<template>
    <div>
        <button
            type="button"
            class="btn btn-danger btn-sm btn-block mb-2 hidden-print"
            data-toggle="modal"
            data-target="#teamCancelEntryModal"
        >
            <i class="fa fa-fw fa-exclamation-triangle"></i> Cancel Entry
        </button>

        <div
            class="modal fade"
            id="teamCancelEntryModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="teamCancelEntryModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="teamCancelEntryModalLabel">Cancel your team entry</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <p v-if="previouslyRefunded">
                            Part of this booking has already been refunded. Please contact the organiser of this event to cancel it.
                        </p>
                        <template v-else>
                            <p>{{ description }}</p>
                            <p v-if="refundAmount > 0">
                                If you proceed with cancellation your team will be refunded {{ refundAmountFormatted }}
                            </p>
                            <p>Cancelling will remove every member of your team from this event.</p>
                            <p>
                                If you purchased any add-ons with your entry, you will need to contact the organiser of the
                                event directly for further assistance - since they will not be transferred, nor
                                removed/refunded, as part of this process.
                            </p>
                        </template>
                    </div>
                    <div v-if="!previouslyRefunded" class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-danger btn-block"
                            :disabled="isSubmitting"
                            @click="cancelTeamEntry"
                        >
                            {{ refundAmount > 0 ? 'Cancel Entry and Process Refund' : 'Cancel Entry' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <notification-container :notifications="notifications"></notification-container>
    </div>
</template>

<script>
import NotificationContainer from '../../Common/NotificationContainer.vue';
import notificationsMixin from '../../../mixins/notifications.js';

export default {
    name: 'TeamCancelEntryModal',
    mixins: [notificationsMixin],
    components: {
        NotificationContainer,
    },
    props: {
        teamId: {
            type: Number,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        refundAmount: {
            type: Number,
            required: true
        },
        refundAmountFormatted: {
            type: String,
            required: true
        },
        previouslyRefunded: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            isSubmitting: false,
        };
    },
    methods: {
        cancelTeamEntry() {
            if (this.isSubmitting) {
                return;
            }

            if (!window.confirm('Are you sure you wish to cancel your team entry?')) {
                return;
            }

            this.isSubmitting = true;

            this.$root.makeApiRequest(async (jwtToken) => {
                return await axios.post(
                    `/api/v0/teams/${this.teamId}/cancel`,
                    {},
                    {
                        headers: {
                            'Authorization': jwtToken,
                            'Accept': 'application/json'
                        }
                    }
                );
            }).then(response => {
                const result = response.data;

                if (result.status !== 'success') {
                    this.showAlertMessage(result.message || 'Something went wrong. Please contact support.', 'error', 5000);
                    this.isSubmitting = false;
                    return;
                }

                $('#teamCancelEntryModal').modal('hide');

                const successMessage = result.data.refunded_amount > 0
                    ? 'Your team entry has been refunded'
                    : 'Your team entry has been cancelled';

                setTimeout(() => {
                    this.showAlertMessage(successMessage, 'success', 5000);
                }, 300);

                // Reload so the page shows the team as removed. The button stays disabled until then
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }).catch(e => {
                let errorMessage = 'Something went wrong. Please contact support.';
                if (e.response && e.response.data && e.response.data.message) {
                    errorMessage = e.response.data.message;
                }

                this.showAlertMessage(errorMessage, 'error', 5000);
                this.isSubmitting = false;
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Teams/Form/TeamCancelEntryModal.vue